import React from 'react';
import { colors } from '@styles/colors';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// Componente reutilizable para títulos
const Titulo = ({ children, color = colors.accent, titulo = '', subtitulo = '', rutaRetorno = null, stateRetorno = null, imagen_titulo = 'doc' }) => {
  const navigate = useNavigate();

  // Función para obtener la ruta de la imagen según el tipo
  const obtenerRutaImagen = (tipo) => {
    switch (tipo) {
      case 'especial':
        return '/especial.png';
      case 'extras':
        return '/extras.png';
      case 'medi':
        return '/medi.png';        
      case 'servi':
        return '/servicios.png';                
      default:
        return '/doc.png';
    }
  };

  return (
    <div id="cajaHeader" style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }}>
      <div id="cajaIconoRetorno"
        onClick={() => {
          if (rutaRetorno) {
            if (stateRetorno) {
              navigate(rutaRetorno, { state: stateRetorno });
            } else {
              navigate(rutaRetorno);
            }
          }
        }}
        style={{
          width: '4.6vh',
          height: '4.6vh',
          backgroundColor: color,
          borderRadius: '3vh',
          transform: 'rotate(0deg)',
          opacity: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.6vh',
          fontFamily: 'Inter',
          fontWeight: 'bold',
          color: '#fff',
          marginLeft: '6vh',
          cursor: rutaRetorno ? 'pointer' : 'default'
        }}
      >
        <ArrowBackIcon style={{ width: '4vh', height: '3vh', color: '#fff' }} />
      </div>
      <div id="cajaTitulo" style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8.76vh',
        width: '69.832vh',
        height: '7.3vh',
        marginLeft: '2vh',
        backgroundColor: '#ACF1F9',
      }}>
        <div id="cajaContenidoTitulo" style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: '0'
        }}>
          <div id="cajaRetorno" style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'flex-start'
          }}>
            <img
              src={obtenerRutaImagen(imagen_titulo)}
              alt=""
              style={{
                width: '5.2vh',
                height: '5.3vh',
                objectFit: 'contain',
                marginLeft: '2.5vh',
                marginTop: '1.3vh',
              }}
            />
            <div id="cajaTextos" style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              marginLeft: '2vh'
            }}>
              <div id="cajaTexto" style={{
                width: '50.4vh',
                height: '2.5vh',
                transform: 'rotate(0deg)',
                opacity: 1,
                display: 'flex',
                alignItems: 'center',
                fontFamily: 'Inter',
                fontWeight: '700',
                fontStyle: 'normal',
                fontSize: '2.7vh',
                lineHeight: '100%',
                letterSpacing: '0%',
                color: '#000',
                marginTop: '1vh'
              }}>
                {titulo}
              </div>
              {subtitulo && (
                <div id="cajaSubtitulo" style={{
                  width: '63.4vh',
                  height: '3.7vh',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  display: 'flex',
                  alignItems: 'center',
                  fontFamily: 'Inter',
                  fontWeight: '400',
                  fontStyle: 'normal',
                  fontSize: '1.5vh',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  color: '#858585'
                }}>
                  {subtitulo}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Titulo;